import * as Yup from 'yup';

// ----------------------------------------------------------------------

export const LojaIntegradaFormSchema = Yup.object().shape({
  apiKey: Yup.string().required('API Key é obrigatório'),
  connected: Yup.boolean(),

});

export type TLojaIntegradaConfigFormSchema = Yup.InferType<typeof LojaIntegradaFormSchema>;

export const lojaIntegradaConfigFormSchemaDefaultValues: TLojaIntegradaConfigFormSchema = {
    apiKey: '',
    connected: false,
};
